import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Card } from 'react-bootstrap';
import LoginForm from '../components/auth/LoginForm';

const LoginPage: FC = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'login' });

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center"
      style={{ minHeight: '100svh' }}
    >
      <Card className="d-none d-sm-block border-dark px-5 pt-2 pb-4">
        <h1 className="mb-4">{t('title')}</h1>
        <LoginForm />
      </Card>
      <Card className="d-xs-block d-sm-none border-0">
        <h1 className="mb-4">{t('title')}</h1>
        <LoginForm />
      </Card>
    </Container>
  );
};

export default LoginPage;
